<template>
  <span>
    <b>
      {{ $t('message.trialPeriodTime.attention', { days: trialDays }) }}
    </b>
    <span>{{ $t('message.trialPeriodTime.info') }}</span>
  </span>
</template>

<script>
export default {
  name: 'TrialingMesssage',
  props: {
    trialDays: {
      type: Number,
      required: true,
    },
  },
}
</script>
